import { useState } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Problem from "../components/Problem";
import Methodology from "../components/Methodology";
import Process from "../components/Process";
import Levels from "../components/Levels";
import Authority from "../components/Authority";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";
import LeadFormModal from "../components/LeadFormModal";
import CursorGlow from "../components/CursorGlow";

export default function Landing() {
    const [formOpen, setFormOpen] = useState(false);
    const openForm = () => setFormOpen(true);
    const { scrollYProgress } = useScroll();
    const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 30 });

    return (
        <div className="relative min-h-screen bg-[#0a0a0a] text-[#e6e6e6]">
            <motion.div
                style={{ scaleX: progress }}
                className="fixed inset-x-0 top-0 z-[120] h-px origin-left bg-gold"
                data-testid="scroll-progress"
            />
            <CursorGlow />
            <Nav onOpenForm={openForm} />
            <main>
                <Hero onOpenForm={openForm} />
                <Marquee />
                <Problem />
                <Methodology />
                <Process />
                <Levels />
                <Authority />
                <FinalCTA onOpenForm={openForm} />
            </main>
            <Footer />
            <LeadFormModal open={formOpen} onClose={() => setFormOpen(false)} />
        </div>
    );
}
